export default "__VITE_ASSET__DImQkeob__"